interface Props {
  children: React.ReactNode;
  colorSwap?: boolean;
  header: number | string;
}

export default function BurnoutInfoCard({ children, colorSwap, header }: Props) {
  if (colorSwap) {
    return (
      <div className='divide-burnout-red/65 bg-burnout-dark-gray divide-y overflow-hidden rounded-lg text-white shadow-sm'>
        <div className='px-4 py-5 text-2xl font-bold sm:px-6'>{header}</div>
        <div className='px-4 py-5 sm:p-6'>{children}</div>
      </div>
    );
  }

  return (
    <div className='divide-burnout-red/65 bg-burnout-light-gray divide-y overflow-hidden rounded-lg text-black shadow-sm'>
      <div className='px-4 py-5 text-2xl font-bold sm:px-6'>{header}</div>
      <div className='px-4 py-5 sm:p-6'>{children}</div>
    </div>
  );
}
